import PromisePool from "@supercharge/promise-pool";
import { useCallback } from "react";
import { toast } from "react-toastify";
import useUserIdToken from "./useUserIdToken";

export const useAddArtists = () => {
  const token = useUserIdToken();

  return useCallback(
    async (artists: { id: number | string }[], listId: string) => {
      const { results } = await PromisePool.for(artists)
        .withConcurrency(10)
        .process(async (artist) => {
          const response = await fetch(
            `/api/lists/${listId}/artists/${artist.id}`,
            {
              method: "POST",
              headers: {
                Authorization: `bearer ${token}`,
                "content-type": "application/json",
              },
            },
          );

          if (!response.ok) {
            throw new Error("Failed to add artist to list");
          }
        });

      toast.success(
        `${results.length} Artist${
          results.length === 1 ? "" : "s"
        } added to list.`,
      );
    },
    [token],
  );
};
